import { render, staticRenderFns } from "./manufacturer-form.vue?vue&type=template&id=7840bc06"
import script from "./manufacturer-form.vue?vue&type=script&lang=ts"
export * from "./manufacturer-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports